import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Register from './pages/Register';
import Welcome from './pages/Welcome';
import BlogWriter from './pages/BlogWriter';
import Dashboard from './pages/Dashboard';
import BlogDashboard from './pages/BlogDashboard';
import UtmGenerator from './pages/UtmGenerator';
import Leadpages from './pages/Leadpages';
import LeadpageManager from './pages/LeadpageManager';

function PrivateRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center" style={{ height: '100vh' }}>
                <div className="spinner" style={{ width: 40, height: 40, border: '3px solid var(--color-border)', borderTopColor: 'var(--color-accent-primary)', borderRadius: '50%' }} />
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/login" />;
}

function PublicRoute({ children }) {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return null;
    }

    return isAuthenticated ? <Navigate to="/" /> : children;
}

function App() {
    return (
        <Routes>
            <Route path="/login" element={
                <PublicRoute>
                    <Login />
                </PublicRoute>
            } />
            <Route path="/register" element={
                <PublicRoute>
                    <Register />
                </PublicRoute>
            } />
            <Route path="/" element={
                <PrivateRoute>
                    <Layout />
                </PrivateRoute>
            }>
                <Route index element={<Welcome />} />
                <Route path="blog-writer" element={<ErrorBoundary><BlogWriter /></ErrorBoundary>} />
                <Route path="blog-writer/:blogId" element={<ErrorBoundary><BlogWriter /></ErrorBoundary>} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="blogs" element={<BlogDashboard />} />
                <Route path="utm" element={<UtmGenerator />} />
                <Route path="leadpages" element={<ErrorBoundary><Leadpages /></ErrorBoundary>} />
                <Route path="leadpages/manage" element={<ErrorBoundary><LeadpageManager /></ErrorBoundary>} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
}

export default App;
